// =============================================================================
// client/src/components/Toast.jsx | v1.0 | S79 | P9a — W-7(g)
// =============================================================================
// RM's toast shape (CampaignBuilder.jsx :93-97) rebuilt in Tailwind. One of the
// two new shared components P9a adds; no third-party UI dependency is added.
//
// Server text is rendered VERBATIM. When a flux route answers 409/503/429 with
// a sentence, that sentence is what the operator sees — the client does not
// paraphrase a server's refusal (§1.1).
// =============================================================================

import { useEffect } from 'react';

const TONE_CLASSES = {
  success: 'bg-mid-green text-white',
  error: 'bg-red-50 border border-red-200 text-red-700',
  info: 'bg-hunter-deep text-white',
};

export default function Toast({ message, tone = 'info', onDismiss, autoHideMs = 6000 }) {
  useEffect(() => {
    if (!message || !onDismiss || !autoHideMs) return undefined;
    const t = setTimeout(onDismiss, autoHideMs);
    return () => clearTimeout(t);
  }, [message, onDismiss, autoHideMs]);

  if (!message) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 max-w-md" role="status" aria-live="polite">
      <div className={`rounded-lg shadow-lg px-4 py-3 text-sm font-body ${TONE_CLASSES[tone] || TONE_CLASSES.info}`}>
        <div className="flex items-start gap-3">
          <span className="flex-1 whitespace-pre-line">{message}</span>
          {onDismiss && (
            <button
              type="button"
              onClick={onDismiss}
              className="opacity-70 hover:opacity-100 font-bold leading-none"
              aria-label="Dismiss"
            >
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
